import { render, staticRenderFns } from "./BrockerDealerCapitalSetting.vue?vue&type=template&id=f7b94292&scoped=true&"
import script from "./BrockerDealerCapitalSetting.vue?vue&type=script&lang=js&"
export * from "./BrockerDealerCapitalSetting.vue?vue&type=script&lang=js&"
import style0 from "./BrockerDealerCapitalSetting.vue?vue&type=style&index=0&id=f7b94292&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b94292",
  null
  
)

export default component.exports